import { z } from 'zod';

export const getMissedVisitsReasonsSchema = z.array(
  z.object({
    id: z.string(),
    name: z.string(),
    isActive: z.boolean(),
    isFromManager: z.boolean(),
    dueToSalesPerson: z.boolean(),
    dueToTraderSite: z.boolean(),
    dueToPlan: z.boolean(),
    sort: z.number().optional(),
  })
);

export type GetMissedVisitsReasonsResponse = z.infer<typeof getMissedVisitsReasonsSchema>;
